import { AfterViewInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList, TemplateRef } from "@angular/core";
import { PrimeTemplate } from "primeng/api";
import { Nullable } from "ng/src/app/shared/model/app.model";
import { BaseComponent } from "ng/src/app/shared/base.component";

@Component({
	selector: 'lb-inplace-editor',
	template:`
		<div *ngIf="!active" class="p-d-inline" [ngClass]="{'clickable':  clickable}" (click)="clickable && activate()">
			<ng-content select="[display]"></ng-content>
			<ng-container *ngTemplateOutlet="displayTemplate"></ng-container>
		</div>
		<div *ngIf="active">
            <div class="p-grid p-fluid">
                <div class="p-col-12">
	                <ng-content select="[content]"></ng-content>
                    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
                </div>
            </div>
            <div class="p-grid p-fluid">
                <div class="p-col">
                    <button pButton class="p-button-secondary" [label]="rejectLabel" icon="pi pi-times" (click)="close('reject')"></button>
                </div>
                <div class="p-col">
                    <button pButton class="p-button-success" [disabled]="acceptEnabled === false" [label]="acceptLabel" icon="pi pi-check" (click)="close('accept')"></button>
                </div>
            </div>
		</div>
	`
})
export class InplaceEditorComponent extends BaseComponent implements AfterViewInit {
	
	@ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
	
	@Input()
	get active() {
		return this._active;
	}
	set active(val) {
		this._active = val;
		this.activeChange.emit(val);
		
		val ? this.onActivate.emit() : this.onDeactivate.emit();
	}
	@Input() acceptLabel = 'Accept';
	@Input() rejectLabel = 'Cancel';
	@Input() clickable = true;
	@Input() acceptEnabled?: boolean;
	
	@Output() onActivate = new EventEmitter();
	@Output() onDeactivate = new EventEmitter();
	@Output() onAccept = new EventEmitter();
	@Output() onReject = new EventEmitter();
	@Output() activeChange = new EventEmitter<boolean>();
	
	displayTemplate = Nullable.of<TemplateRef<any>>();
	contentTemplate = Nullable.of<TemplateRef<any>>();
	
	private _active = false;
	
	ngAfterViewInit(): void {
		setTimeout(() => {
			this.updateTemplatesInplace();
		})
	}
	
	updateTemplatesInplace() {
		this.templates.forEach(p => {
			switch (p.getType()) {
				case 'display':
					this.displayTemplate = p.template;
					break;
				case 'content':
					this.contentTemplate = p.template;
					break;
			}
		});
	}
	
	activate() {
		this.active = true;
	}
	
	close(status: 'accept' | 'reject') {
		if (status === 'accept')
			this.onAccept.emit();
		else
			this.onReject.emit();
		
		this.active = false;
	}
}